export const subscriptionTypesList = [
  { label: "ALL", value: "" },
  { label: "INTERNAL", value: "INTERNAL" },
  { label: "PURCHASE", value: "PURCHASE" },
  { label: "FREE_SLOT", value: "FREE_SLOT" },
  { label: "UPGRADED", value: "UPGRADED" },
  { label: "DOWNGRADED", value: "DOWNGRADED" }
];
